export default "/images/vendor/flag-icon-css/flags/4x3/ba.svg?83f603448a9e984610b0f53df5029d9a";